/**
 * @author: Wangwei
 * @description: 打卡营首页 Tabs切换卡片列表数据
 */
import styles from './css/campListCard.less';
import { useState } from 'react';
import cx from 'classnames';
import { Divider, Space, Skeleton } from 'antd';
import { getCampIndexPage } from '@/utils/requests/camp/requests_index';
import DateFormat from '@/components/dateFormat';
import { PageCampVO } from '@/types/camp/campIndex/indexTypes';
import { InfiniteScroll } from 'antd-mobile';
import wenhaoPng from '@/static/images/wenhao.png';

interface props {
  id: number;
}

const CampListCard: React.FC<props> = ({ id }) => {
  const [dataList, setDataList] = useState<PageCampVO[]>([]);

  const [ellipsis, setEllipsis] = useState(true);
  const [current, setCurrent] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [loading, setLoading] = useState(true);

  const resParams: any = {
    current: current,
    size: 10,
  };
  if (id !== -1) {
    resParams.products = [id];
  }

  const getCampPageRun = () =>
    getCampIndexPage(resParams)
      .then((res: any) => {
        setTotal(res.data.total);
        if (dataList) {
          setDataList([...dataList, ...res.data.records]);
        } else {
          setDataList([...res.data.records]);
        }
        setCurrent(current + 1);
        setTotal(res.data.total);
        setHasMore(res.data.current < res.data.pages);
      })
      .finally(() => {
        setTimeout(function () {
          setLoading(false);
        }, 200);
      });

  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <div></div>
          </>
        ) : total > 0 ? (
          <span>—— 没有更多了 ——</span>
        ) : (
          ''
        )}
      </>
    );
  };

  function timeFrame(enTime: string, stTime: string): number {
    const endTime = new Date(enTime);
    const startTime = new Date(stTime);
    const millisecondsDiff = endTime.getTime() - startTime.getTime();
    const daysDiff = Math.floor(millisecondsDiff / (1000 * 60 * 60 * 24));
    return Math.abs(daysDiff);
  }

  function extractMonthAndDay(stTime: string): string {
    const date = new Date(stTime);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}-${day}`;
  }

  return (
    <>
      {loading && (
        <div className={styles.camp_all_list}>
          {Array.from({ length: 4 }, (_, index) => (
            <div key={index} className={styles.item}>
              <div className={styles.thumb}>
                <Skeleton.Image active className={styles.img} />
              </div>
              <div className={styles.info_box} style={{ paddingTop: 24 }}>
                <Skeleton active paragraph={{ rows: 4 }} />
              </div>
              <div style={{ marginTop: 24, padding: '0 18px' }}>
                <Skeleton.Button active block style={{ height: 40 }} />
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && dataList && dataList.length > 0 ? (
        <div className={styles.camp_all_list}>
          {dataList.map((item, index: number) => (
            <div key={index} className={styles.item}>
              <div className={styles.thumb}>
                <img className={styles.img} width={268} src={item.cover} alt="" />
              </div>

              <div className={styles.info_box}>
                <div className={cx(styles.title, 'f16 col172 hide_txt')} style={{ width: 252 }}>
                  {item.name}
                </div>
                <div>
                  <Space split={<Divider type="vertical" />} className="f12 colc5c">
                    {item.batchInfo && (
                      <span>
                        限 {timeFrame(item.batchInfo.enTime, item.batchInfo.stTime)} 天内完成
                      </span>
                    )}
                    <span>{item.campAllStudent} 人参与</span>
                  </Space>
                </div>
                <div className={cx(styles.description, 'col808 f12')}>
                  {item.info && item.info.includes('\n') ? (
                    <div style={{ whiteSpace: 'pre-line' }}>{item.info}</div>
                  ) : (
                    item.info
                  )}
                </div>
                <div className={styles.line}></div>
                {item.batchInfo ? (
                  <>
                    <div>
                      <DateFormat endTime={item.batchInfo.stTime} startText="报名截止：" />
                    </div>
                    <a
                      className={cx(styles.enroll, 'flex_4')}
                      href={`/v2/camp/${item.id}`}
                      target="_blank"
                      style={{ gap: 6, marginTop: 8 }}
                    >
                      <span className="f14">了解详情</span>
                      <span className="f14">({extractMonthAndDay(item.batchInfo.stTime)}开营)</span>
                    </a>
                  </>
                ) : (
                  <>
                    <div>暂无开班计划</div>
                    <a
                      className={cx(styles.enroll, styles.enroll_def, 'flex_4')}
                      href={`/v2/camp/${item.id}`}
                      target="_blank"
                      style={{ gap: 6 }}
                    >
                      <span className="f14">了解详情</span>
                    </a>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        !loading && (
          <div className="flex_4_1" style={{ padding: '60px 0 100px' }}>
            <img src={wenhaoPng} width={200} height={200} />
            <div className="col808">抱歉，当前分类下暂无打卡营！</div>
          </div>
        )
      )}
      <InfiniteScroll loadMore={getCampPageRun} hasMore={hasMore}>
        <InfiniteScrollContent hasMore={hasMore} />
      </InfiniteScroll>
    </>
  );
};
export default CampListCard;
